'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chart_utility = require('../../../../packages/common-utilities/src/chart_utility.js');

var _chart_utility2 = _interopRequireDefault(_chart_utility);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _chart_utility3 = require('../../../../packages/common-utilities/src/chart_utility');

var _date_formatter = require('../../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _formatted_number = require('../global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _number_utility = require('../../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _string_utility = require('../../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _tracking_utility = require('common-utilities/src/tracking_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DailyWeeklyLiquidityChart = function (_React$Component) {
  _inherits(DailyWeeklyLiquidityChart, _React$Component);

  function DailyWeeklyLiquidityChart(props) {
    _classCallCheck(this, DailyWeeklyLiquidityChart);

    var _this = _possibleConstructorReturn(this, (DailyWeeklyLiquidityChart.__proto__ || Object.getPrototypeOf(DailyWeeklyLiquidityChart)).call(this, props));

    _this.trackChartHover = false;
    return _this;
  }

  _createClass(DailyWeeklyLiquidityChart, [{
    key: 'createDailyWeeklyLiquidityChart',
    value: function createDailyWeeklyLiquidityChart(printWidth) {
      var _this2 = this;

      var data = this.props.fundValuationData.filter(function (fundData) {
        return !(0, _ramda.isNil)(fundData.liquidityWeeklyPercentage) && !(0, _ramda.isNil)(fundData.liquidityDailyPercentage);
      }).map(function (item) {
        item.formattedDate = _date_formatter2.default.getLocalFormattedDateForInjectIntl(item.date, _this2.props.intl);
        item.formattedLiquidityWeeklyPercentage = _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(item.liquidityWeeklyPercentage, 2)), _this2.props.numberFormat);
        item.formattedLiquidityDailyPercentage = _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(item.liquidityDailyPercentage, 2)), _this2.props.numberFormat);

        return item;
      });

      var isDesktop = this.props.breakpoint > 3;
      var endDate = data[data.length - 1].date;
      var xAxisTicks = [];
      var dateFormat = this.props.intl.formatMessage({ defaultMessage: "%m/%d/%Y", id: "pdp-chart-date-format" });

      if (_chart_utility2.default.isInputDateLessThanSixMonthOld(this.props.fundInceptionDate)) {
        xAxisTicks = _chart_utility2.default.createXAxisTicksForLessThanSixMonthOldFund(this.props.fundInceptionDate, isDesktop);
      } else {
        xAxisTicks = _chart_utility2.default.createXAxisTicks(endDate, isDesktop);
      }
      var marginRight = isDesktop ? 20 : 10;

      /* eslint-disable*/
      var spec = (0, _ramda.mergeDeepLeft)({
        "keys": ["date"],
        "container": {
          "rangePaddingRight": 24,
          "marginBottom": 50,
          "marginLeft": 50,
          "marginRight": marginRight
        },
        "style": {
          "fill": ["#70C4FF", "#00A16D", "#70C4FF", "#00A16D"]
        },
        "values": this.props.showBenchmarks ? ["liquidityWeeklyPercentage", "liquidityDailyPercentage", "benchmark50", "benchmark25"] : ["liquidityWeeklyPercentage", "liquidityDailyPercentage"],
        "type": "line",
        "axis": {
          "x": {
            "shows": true,
            "label": {
              "show": true,
              "text": function text(d) {
                return d3.timeFormat(dateFormat)(d);
              }
            },
            "tick": {
              "padding": 5,
              "ticks": 6,
              "values": xAxisTicks
            },
            "domain": [xAxisTicks[0], xAxisTicks[xAxisTicks.length - 1]]
          },
          "y": {
            "domain": [0, 100],
            "label": {
              "show": true,
              "text": function text(d) {
                if (d === 0) {
                  return "";
                } else {
                  return d + "%";
                }
              }
            },
            "tick": {
              "padding": 5,
              "grid": true,
              "style": {
                "stroke": "lightgrey"
              },
              "values": this.props.showBenchmarks ? [0, 10, 20, 25, 30, 40, 50, 60, 70, 80, 90, 100] : [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
            },
            "show": true
          }
        },
        "hoverLine": {
          "tooltip": {
            "text": function text(item) {
              if (!_this2.trackChartHover) {
                _tracking_utility.TrackingUtility.trackEvent({
                  "eventCategory": _tracking_utility.TrackingUtility.getEventCategory("pdp"),
                  "eventAction": "daily & weekly liquid assets chart",
                  "eventLabel": _tracking_utility.TrackingUtility.getEventLabel("chartHover")
                });
                _this2.trackChartHover = true;
              }
              var tooltiptext = "<div>";
              var formattedItem = data.find(function (dataPoint) {
                return dataPoint.date === item.date;
              });
              tooltiptext += "<div style= 'text-align:left; font-weight:100;' class='caption'> " + formattedItem.formattedDate + "</div>";
              tooltiptext += "<div style= 'text-align:left' > <div style = 'width: 10px; height: 10px; background-color: #70C4FF; display: inline-block; border-radius: 25px;'> </div>  <span class='caption' style='font-weight: 100'>" + _string_utility2.default.getLocalizedString(_this2.props.intl, "Weekly Liquidity", "pdp-weekly-liquidity-label") + ":</span> <span class='caption' style='font-weight: 400'>" + formattedItem.formattedLiquidityWeeklyPercentage + "%</span> </div>";
              tooltiptext += "<div style= 'text-align:left'> <div style = 'width: 10px; height: 10px; background-color: #00A16D; display: inline-block; border-radius: 25px;'> </div>  <span class='caption font-light' style='font-weight: 100'>" + _string_utility2.default.getLocalizedString(_this2.props.intl, "Daily Liquidity", "pdp-daily-liquidity-label") + ":</span> <span class='caption' style='font-weight: 400'>" + formattedItem.formattedLiquidityDailyPercentage + "%</span> </div>";
              tooltiptext += "</div> ";
              return tooltiptext;
            }
          }
        },
        "postProcessing": function postProcessing(chart) {
          chart.getPlot().selectAll(".tick line").style("stroke", "lightgrey");
        }
      }, _chart_utility3.COMMON_CHART_CONFIG);

      if (printWidth && typeof printWidth === "number") {
        spec.container.width = (0, _chart_utility3.getChartPrintWidth)();
        spec.container.height = (0, _chart_utility3.getChartPrintHeight)();
      }

      return (0, _chart_utility.generateChart)((0, _chart_utility3.generateChartId)("DailyWeeklyLiquidityChart", printWidth && typeof printWidth === "number"), "linechart", data, spec);
    }
  }, {
    key: 'render',
    value: function render() {
      var dailyWeeklyLiquidityChart = this.createDailyWeeklyLiquidityChart();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'print-hide' },
          _react2.default.createElement(dailyWeeklyLiquidityChart)
        ),
        _react2.default.createElement(
          'div',
          { className: 'print-display', style: { display: "none" } },
          _react2.default.createElement(this.createDailyWeeklyLiquidityChart(800))
        )
      );
    }
  }]);

  return DailyWeeklyLiquidityChart;
}(_react2.default.Component);

/* eslint-enable*/


exports.default = (0, _reactIntl.injectIntl)(DailyWeeklyLiquidityChart);